import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDButton from "components/MDButton"
import MDTypography from "components/MDTypography"

const EmptyState = ({
  icon = "add_circle_outline",
  title,
  description,
  example,
  actionLabel,
  onAction,
}) => (
  <MDBox
    textAlign="center"
    py={4}
    px={2}
    borderRadius="lg"
    border="1px dashed"
    borderColor="grey-300"
    bgColor="grey-100"
  >
    <MDBox
      width="3rem"
      height="3rem"
      borderRadius="50%"
      bgColor="white"
      color="info"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      shadow="sm"
      mb={1.5}
    >
      <Icon fontSize="small">{icon}</Icon>
    </MDBox>
    <MDTypography variant="button" fontWeight="medium" display="block" mb={0.5}>
      {title}
    </MDTypography>
    <MDTypography variant="body2" color="text" display="block" mb={example ? 1 : 2}>
      {description}
    </MDTypography>
    {example && (
      <MDTypography
        variant="caption"
        color="text"
        display="block"
        mb={2}
        sx={{ fontStyle: "italic" }}
      >
        Example: {example}
      </MDTypography>
    )}
    {actionLabel && onAction && (
      <MDButton variant="gradient" color="info" size="small" onClick={onAction}>
        {actionLabel}
      </MDButton>
    )}
  </MDBox>
)

export default EmptyState
